import { render, staticRenderFns } from "./splitpane.vue?vue&type=template&id=787b3ba4&"
import script from "./splitpane.vue?vue&type=script&lang=js&"
export * from "./splitpane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787b3ba4')) {
      api.createRecord('787b3ba4', component.options)
    } else {
      api.reload('787b3ba4', component.options)
    }
    module.hot.accept("./splitpane.vue?vue&type=template&id=787b3ba4&", function () {
      api.rerender('787b3ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/layout/splitpane.vue"
export default component.exports